<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="required ts-text-xs">
            {{ $t('scoreComponent.mainProgram') }}
          </label>
          <a-select
            v-model="model.acp_id"
            style="width:100%"
            :options="main_programs"
            :disabled="disabled_edit"
            @change="fetchGrade"
          ></a-select>
          <div class="validate" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <label class="ts-text-xs">
            {{ $t('scoreComponent.grade') }}
          </label>
          <a-select
            mode="multiple"
            v-model="model.grade_id_list"
            style="width:100%"
            option-filter-prop="children"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            :options="grade_list"
            :show-search="true"
            :max-tag-text-length="100"
          ></a-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="required ts-text-xs">
            {{ $t('scoreComponent.componentName') }}
          </label>
          <input
            v-model.trim="model.score_component"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('score_component')">
            {{ errors.first('score_component') }}
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="ts-bg-gray-200 ts-p-2 ts-rounded">
            <div class="d-flex justify-content-between">
              <label class="required ts-text-xs">
                {{ $t('scoreComponent.component') }}
              </label>
              <div>
                <a
                  href="#"
                  v-tooltip="$t('scoreComponent.addMoreComponent')"
                  @click.prevent="addComponent"
                >
                  <i class="far fa-plus-square"></i>
                </a>
              </div>
            </div>
            <table style="width:100%" class="mt-1">
              <draggable tag="tbody" v-model="model.score_component_list">
                <tr
                  v-for="(item, index) in model.score_component_list"
                  :key="index"
                >
                  <td style="padding: 3px 8px 7px 0;">
                    <input
                      v-model.trim="item.sc_item_name"
                      type="text"
                      class="bb"
                      style="width:100%"
                    />
                    <div
                      class="validate"
                      v-if="
                        errors.has(
                          'score_component_list.' + index + '.sc_item_name'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'score_component_list.' + index + '.sc_item_name'
                        )
                      }}
                    </div>
                  </td>
                  <td style="width:10px" valign="top">
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fas fa-times"></i>
                    </a>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12 text-right">
          <slot name="action-button"></slot>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { Errors } from 'form-backend-validation'

export default {
  name: 'scoreComponentForm',
  props: ['value', 'validate'],
  components: {
    draggable
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      main_programs: [],
      grade_list: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
    if (this.value.acp_id != null) {
      this.fetchGrade(this.value.acp_id)
    }
  },
  computed: {
    disabled_edit() {
      return this.model.sc_id > 0
    }
  },
  methods: {
    addComponent() {
      this.model.score_component_list.push({
        sc_item_id: 0,
        sc_item_name: null
      })
    },
    removeItem(index) {
      this.model.score_component_list.splice(index, 1)
    },
    async fetchData() {
      this.loading = true
      await this.$store
        .dispatch('scoreComponent/getMainProgram')
        .then(response => {
          this.main_programs = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchGrade() {
      if (!this.model.acp_id) {
        return
      }
      await this.$store
        .dispatch('scoreComponent/getGrade', this.model.acp_id)
        .then(response => {
          this.grade_list = response.data.map(el => ({
            value: el.grade_id,
            label: el.grade_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.bb {
  border: none;
  outline: none !important;
  padding: 3px 7px;
  border-radius: 5px;
}
</style>
